module.exports = __webpack_public_path__ + "img/mahanakhon-white-ale.92ccf540.png";